import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  SxProps,
} from "@mui/material";
import { SyntheticEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ArrowContainedIcon from "../../assets/Icons/ArrowContainedIcon";
import { ProfilePageAccordion } from "../../constants/ProfilePage";
import { theme } from "../../mui-customs/Theme";
import { setExpandedAccordion } from "../../redux/createProfilePageSlice";
import { RootState } from "../../redux/store";
import Typography from "../Typography";

interface ProfileAccordionContainerProps extends AccordionProps {
  name: string;
  value?: ProfilePageAccordion;
  sx?: SxProps;
  optimized?: boolean;
}

const ProfileAccordionContainer = ({
  children,
  name,
  value,
  sx,
  defaultExpanded,
  optimized = false,
  ...props
}: ProfileAccordionContainerProps) => {
  const dispatch = useDispatch();
  const [localExpandState, setLocalExpandState] = useState(defaultExpanded);
  const handleAccordionChange = (event: SyntheticEvent, expanded: boolean) => {
    if (value === undefined) {
      setLocalExpandState(expanded);
    } else {
      dispatch(setExpandedAccordion(expanded ? value : null));
    }
  };
  const expandedAccordion = useSelector(
    (state: RootState) => state.profilePage.expandedAccordion
  );

  return (
    <Accordion
      disableGutters={true}
      sx={{
        boxShadow: "none",
        py: 1,
        "&::before": {
          display: "none",
        },
      }}
      onChange={handleAccordionChange}
      expanded={
        value !== undefined ? expandedAccordion === value : localExpandState
      }
      {...props}
    >
      <AccordionSummary
        expandIcon={<ArrowContainedIcon />}
        sx={{
          px: "0px",
          "& .Mui-expanded p": {
            color: `${theme.brand1[500]} !important`,
          },
        }}
      >
        <Typography variant="title2" sx={{ color: theme.grey2[500] }}>
          {name}
        </Typography>
      </AccordionSummary>
      {optimized ? (
        (value !== undefined
          ? expandedAccordion === value
          : localExpandState) && (
          <AccordionDetails sx={{ px: "0px", ...sx }}>
            {children}
          </AccordionDetails>
        )
      ) : (
        <AccordionDetails sx={{ px: "0px", ...sx }}>
          {children}
        </AccordionDetails>
      )}
    </Accordion>
  );
};

export default ProfileAccordionContainer;
